
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
export default function Footer() {

    const links = [
        "Press Release",
        "About Us",
        "Our Consultants",
        " Real Estate ",
        "Contact Us"
    ]

    const footLinks = [
        "Press Release",
        "Products",
        "Clients",
        "Countries",
        "Get Owner"
    ]

    return (

        <>
            <div className="bg-[#181818]  mt-24 py-32 w-full relative md:px-12">

                <div className="bg-transparent relative text-white flex justify-center  flex-wrap md:justify-around items-start gap-10">

                    <div className='bg-transparent'>
                        <div className='bg-transparent'>
                            <StarRoundedIcon sx={{ bgcolor: "transparent", color: "#539d56" }} />
                            <StarRoundedIcon sx={{ bgcolor: "transparent", color: "#539d56" }} />
                            <StarRoundedIcon sx={{ bgcolor: "transparent", color: "#539d56" }} />
                            <StarRoundedIcon sx={{ bgcolor: "transparent", color: "#539d56" }} />
                            <StarRoundedIcon sx={{ bgcolor: "transparent", color: "#539d56" }} />
                            <p className='bg-transparent text-[#539d56] w-full underline underline-offset-4  text-xl py-3'> 99.9% Customer Satisfaction </p>

                        </div>

                        <div className='bg-transparent mt-8 flex gap-2'>

                            <p className='bg-[#464646] transition-colors duration-200 w-10 p-2 hover:bg-[#539d56]  rounded-[50%]'><a href='ad' className='bg-transparent'> <FacebookRoundedIcon sx={{ bgcolor: "transparent", margin: " " }} /> </a> </p>
                            <p className='bg-[#464646] transition-colors duration-200 w-10 p-2 h-10  flex justify-center items-center hover:bg-[#539d56]  rounded-[50%]'><a href='ad' className='bg-transparent'> <XIcon sx={{ bgcolor: "transparent", fontSize: "20px " }} /> </a> </p>
                            <p className='bg-[#464646] transition-colors duration-200 w-10 p-2 hover:bg-[#539d56]  rounded-[50%]'><a href='ad' className='bg-transparent'> <InstagramIcon sx={{ bgcolor: "transparent", margin: " " }} /> </a> </p>
                            <p className='bg-[#464646] transition-colors duration-200 w-10 p-2 hover:bg-[#539d56]  rounded-[50%]'><a href='ad' className='bg-transparent'> <WhatsAppIcon sx={{ bgcolor: "transparent", margin: " " }} /> </a> </p>


                        </div>
                    </div>




                    <div className="bg-transparent flex flex-col gap-3 ">

                        <h6 className="bg-transparent text-xl ">South Global Exim </h6>

                    {
                        links.map((link)=>(

                            <ul className="bg-transparent flex flex-col gap-3">

                            <li className="bg-transparent hover:text-[#539d56]"> <a href="dsd" className="bg-transparent font-[300]"> {link}  </a> </li>
                         
                        </ul>
                        ))
                    }


                    </div>


                    <div className="bg-transparent flex flex-col gap-3 w-auto justify-center  ">

                        <h6 className="bg-transparent text-xl ">Other Links </h6>
                        {
                        footLinks.map((link)=>(

                            <ul className="bg-transparent flex flex-col gap-3">

                            <li className="bg-transparent hover:text-[#539d56]"> <a href="dsd" className="bg-transparent font-[300]"> {link}  </a> </li>
                         
                        </ul>
                        ))
                    }

                    </div>

                    <div className="bg-transparent px-4 flex flex-col top-0  gap-10  justify-center">

                        <h6 className="bg-transparent text-xl"> Address</h6>
                        <p className="bg-transparent font-[300] w-[80%] -mr-48"> Suite 112 91809 Near Stanley Court, Kundeville, OR 17447,Maraharashtra, India </p>

                    </div>

                </div>


            </div>
            <div className='h-24 bg-[#111111] text-center bottom-0 flex justify-center items-center'>
                <p className='bg-transparent text-white'>Copyright: © 2025 by <span className='bg-transparent text-[#539d56]'> South Global EXIM</span>. All Rights Reserved.</p>

            </div>

        </>

    );

}